module.exports = __webpack_public_path__ + "img/primary-list-icon.dfb39427.svg";